import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentService} from '../../services/payment/payment.service';

@Component({
  selector: 'app-put-to-balance',
  templateUrl: './put-to-balance.component.html',
  styleUrls: ['./put-to-balance.component.scss']
})
export class PutToBalanceComponent implements OnInit {
  static dialogRef;
  putForm: FormGroup;
  constructor(
    private paymentService: PaymentService
  ) { }

  ngOnInit() {
    this.putForm = new FormGroup({
      'amount': new FormControl(null, [Validators.required]),
    });
  }

  save() {
    // console.log(this.putForm);
    this.paymentService.putToBalance(this.putForm.get('amount').value).subscribe(
      // resp => console.log(resp)
    );
  }
}
